import React from "react";
import styled from "styled-components";
import { Section, Container, Eyebrow, H2, Lead, CenteredHead } from "../components/ui";

const Stats = styled.dl`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  max-width: 880px;
  margin: 0 auto;

  @media screen and (max-width: 48em) {
    grid-template-columns: 1fr;
    max-width: 22rem;
  }
`;

const Stat = styled.div`
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  text-align: center;
  padding: 1.75rem 1.25rem;
  border: 1px solid var(--line);
  border-radius: 20px;
  background: #ffffff;

  dt {
    font-family: var(--fontR);
    font-size: 0.875rem;
    line-height: 1.45;
    color: var(--text-lo);
    max-width: 13rem;
  }

  dd {
    font-family: var(--fontL);
    font-size: 2.75rem;
    font-weight: 600;
    letter-spacing: -0.03em;
    line-height: 1.1;
    font-variant-numeric: tabular-nums;
    color: var(--text-hi);
    margin-bottom: 0.375rem;
  }
`;

const Source = styled.p`
  margin-top: 1.5rem;
  text-align: center;
  font-family: var(--fontR);
  font-size: 0.8125rem;
  color: var(--text-lo);

  a {
    color: var(--text-hi);
    text-underline-offset: 3px;
  }
`;

export const CoachiiStats = () => (
  <>
    <Stats>
      <Stat data-reveal style={{ "--reveal-i": 0 }}>
        <dt>personnes accompagnées en coaching individuel</dt>
        <dd>+20</dd>
      </Stat>
      <Stat data-reveal style={{ "--reveal-i": 1 }}>
        <dt>investis grâce à ces conseils</dt>
        <dd>+2 M€</dd>
      </Stat>
      <Stat data-reveal style={{ "--reveal-i": 2 }}>
        <dt>de clients satisfaits</dt>
        <dd>100 %</dd>
      </Stat>
    </Stats>
    <Source>
      Chiffres de{" "}
      <a href="https://www.coachii.be/" target="_blank" rel="noopener noreferrer">
        Coachii
      </a>
      , le coaching à l'origine de Nea.
    </Source>
  </>
);

// Social proof: no invented user counts, the track record is the coaching practice Nea comes from
const Origin = () => (
  <Section id="origine" style={{ paddingTop: "4.5rem", paddingBottom: "4.5rem" }}>
    <Container>
      <CenteredHead data-reveal>
        <Eyebrow>D'où vient Nea</Eyebrow>
        <H2>Née du coaching financier, pas d'un tableur.</H2>
        <Lead style={{ maxWidth: "40rem" }}>
          Avant l'app, il y a eu Coachii : du coaching financier en tête-à-tête. Ça marche, mais un coach n'aide qu'une
          personne à la fois. Nea, c'est la même méthode, digitalisée pour que tout le monde puisse comprendre son
          argent, mieux le gérer, et simplement lui parler.
        </Lead>
      </CenteredHead>

      <CoachiiStats />
    </Container>
  </Section>
);

export default Origin;
